import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const EXTERNALSERVICE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ExternalService.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('description', 'Entity.ExternalService.Description')
    .maxLength(300)
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.ExternalService.IsActive')
    .build(),
];

export const EXTERNALSERVICE_CONFIG = {
  entityName: 'ExternalService',
  localizationKey: 'General::Entity.ExternalService',
  fields: EXTERNALSERVICE_FIELDS,
  permission: 'General.ExternalServices',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: undefined,
};
